<template>
  <section id="the-carousel" class="pos-relative v-box-shadow">
    <div class="logo-main">
      <v-avatar color="#60a8e7" :size="C_avatar.border">
        <v-avatar :size="C_avatar.main">
          <v-img src="@/assets/imgs/ALanding/logo-second.png"></v-img>
        </v-avatar>
      </v-avatar>
    </div>
    <!-- height="94vh" -->
    <v-carousel
      class=""
      height="400px"
      hide-delimiters
      :show-arrows="false"
      continuous
      cycle
    >
      <v-carousel-item v-for="(item, itemInd) in items" :key="itemInd">
        <!-- contain -->
        <!-- height="94vh" -->
        <v-img
          eager
          height="400px"
          :src="require(`@/assets/imgs/ALanding/${item.img}.jpg`)"
        >
          <v-sheet
            height="100%"
            color="transparent"
            width="100%"
            class="d-flex align-end justify-center pos-relative"
          >
            <v-toolbar
              color="#00000063"
              class="pa-5 text-center d-flex align-center justify-center"
            >
              <div class="white--text text-h6 font-weight-bold">
                {{ item.title }}
              </div>
            </v-toolbar>
          </v-sheet>
        </v-img>
      </v-carousel-item>
    </v-carousel>
  </section>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        img: "publications-design",
        title: "تصميم مطبوعات",
      },
      {
        img: "digital-marketing",
        title: "التسويق الرقمي",
      },
      {
        img: "respnsive-design",
        title: "تصميم متجاوب",
      },
      {
        img: "web-design",
        title: "تصميم مواقع",
      },
      // {
      //   img: "web-design-2",
      //   title: "تصميم مواقع",
      // },
    ],
  }),
  computed: {
    C_avatar() {
      return this.$vuetify.breakpoint.smAndUp
        ? { border: 200, main: 180 }
        : { border: 150, main: 130 };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
.logo-main {
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  @media #{map-get($display-breakpoints,"xs-only")} {
    transform: translate(20px, -55px) !important;
  }
  //   transform: translateX(20px);
  transform: translate(20px, 60px);
}
.pos-relative {
  position: relative;
}
</style>